import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
  MDBCardTitle,
  MDBCardText,
  MDBCheckbox


}
from 'mdb-react-ui-kit';
import '../../../css/index.css';



function EditarEscola() {
  const navigate = useNavigate();
  const [escola, setEscola] = useState([]);
  const util = require('../../../utils/index');
  const userLogin = util.getUser();
  const api = require('../../../apis/escola')
  const {id} = useParams();

  const [formValue, setFormValue] = useState({
    id: '',
    idEscola: '', 
    nomeEscola: '', 
    senha: ''
  });

  const [checked, setChecked] = useState(false);

  const handleSubmit = async (values) => {
    console.log(formValue);
    values.preventDefault();
    util.isSubmitting()
    const result = await api.atualizarEscolaApi(formValue);
    result ? toast.success("Atualizado com sucesso!") && navigate("/area-escola") : null;
    util.isSubmitting()
    
  }

  const handleDelet = async () => {
    const object = {
        id: id
    }
    util.isSubmitting()
    const result = await api.excluirEscolaApi(object);
    result ? toast.success("Excluido com sucesso!") && navigate("/area-escola") : null;
    util.isSubmitting()
    
  }

  useEffect(() => {
    const getEscola = async () => {
      try {
        const object = {
          id: id,
        };
        const response = await api.pegarEscolaApi(object);
        const data = await response;
        
        setEscola(data[0]);
        
        setFormValue({
          id: id,
          idEscola: data[0].idescola, 
          nomeEscola: data[0].nomeescola, 
          senha: data[0].senha
        });
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };

    getEscola();
  }, [id]);

  const onChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  const onBlur = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
       minHeight:'500',display:"flex", justifyContent:"center", alignItems:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex flex-column my-5 align-items-center'>

          <MDBCard className='bg-dark text-white w-50' style={{borderRadius: '1rem', minWidth: '300px'}}>
              <MDBCardBody className='d-flex flex-column align-items-center'>

              <MDBCardTitle className='text-white my-5'>Bem vindo, {userLogin.nomeusuario}</MDBCardTitle>
                  <MDBValidation className='w-100' onSubmit={!checked ? handleSubmit : handleDelet}>
                    <MDBValidationItem feedback='Por favor digite a coligada da escola!' invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100' 
                        labelClass='text-white' 
                        label='Coligada' 
                        name='idEscola'
                        id='formControIdEscola' 
                        type='text' 
                        size="lg"
                        value={formValue.idEscola || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    <MDBValidationItem feedback='Por favor digite o nome da escola!' invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100' 
                        labelClass='text-white' 
                        label='Noma da escola' 
                        name='nomeEscola'
                        id='formControNomeEscola' 
                        type='text' 
                        size="lg"
                        value={formValue.nomeEscola || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    <MDBValidationItem feedback='Por favor digite o login!' invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100' 
                        labelClass='text-white' 
                        className='bg-dark'
                        label='Login' 
                        name='login'
                        id='formControLogin' 
                        type='text' 
                        size="lg"
                        value={escola.login || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white", opacity:0.4}}
                        disabled={true}
                        />
                    </MDBValidationItem >
                    <MDBValidationItem feedback='Por favor digite a senha!' invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100' 
                        labelClass='text-white' 
                        label='Senha' 
                        name='senha'
                        id='formControSenha' 
                        type='password' 
                        size="lg"
                        value={formValue.senha || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    
                    
                    <div className='my-2'>
                        <MDBCheckbox

                            id='controlledCheckbox'
                            label='Habilitar botão "Exluir"'
                            checked={checked}
                            onChange={() => setChecked(!checked)}
                        />
                    </div>
                    <div className='d-flex justify-content-between align-items-center flex-column'>
                        <MDBBtn 
                            outline 
                            className='my-3 btn-home w-100' 
                            color='white' 
                            size='lg'
                            type='submit'   
                            id='submitForm'  
                            disabled={!checked}                 
                            >
                            
                            excluir
                        </MDBBtn>
                        <MDBBtn 
                            outline 
                            className='px-5 w-100 btn-home' 
                            color='white' 
                            size='lg'
                            type='submit'   
                            id='submitForm'  
                            disabled={false}                 
                            >
                            
                            Editar
                        </MDBBtn>
                      </div>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 mt-4 btn-home' 
                        color='white' 
                        size='sm'
                        type='submit'   
                        onClick={() => {
                          navigate("/listar-escola")
                        }}
                        >
                        
                        Voltar
                      </MDBBtn>
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>
      </MDBRow>

    </MDBContainer>
  );
}

export default EditarEscola;